<template>
  <b-field :label="t('MemberName')">
    <b-input
      required
      expanded
      v-model="memberName"
      :placeholder="canEdit ? t('MemberNameInput') : ''"
      :validation-message="t('FieldIsRequired', { fieldName: t('MemberName') })"
      :disabled="canEdit === false"
      data-test-id="memberName"
      ref="memberNameRef"
    />
  </b-field>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  modelValue?: string
  canEdit: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | undefined): void
}>()

const { t } = useI18n()

const memberName = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const memberNameRef = ref<{ checkHtml5Validity: () => boolean } | null>(null)

const checkHtml5Validity = (): boolean | undefined => {
  return memberNameRef.value?.checkHtml5Validity()
}

defineExpose({
  checkHtml5Validity
})
</script>
